/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { isElectron, isWindows } from "react-device-detect";
import styled from "styled-components";

import { Layer } from "@vienna/common";

import { VIENNA_TOPBAR_HEIGHT } from "src/lib/constants";

export const StyledAppTobar = styled.div`
  font-family: "IBM Plex Mono";
  display: flex;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  justify-content: space-between;
  align-items: center;
  height: ${VIENNA_TOPBAR_HEIGHT}px;
  border-bottom: ${({ theme }) => `1px solid ${theme.subtleContrast}`};
  padding: 15px;
  width: inherit;
  z-index: ${Layer.TOPBAR};
  background-color: ${({ theme }) => theme.background};
  user-select: none;
  -webkit-app-region: drag;
  @media print {
    display: none;
  }
`;

export const StyledTopbarLeft = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-left: ${isElectron && !isWindows ? "63px" : ""};
  -webkit-app-region: no-drag;
`;

export const StyledTopbarRight = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  -webkit-app-region: no-drag;
`;
